export default {
  name: 'home',
  props: {
    signedInUser: Object
  },
  created () {
    this.redirectToDashboard()
  },
  methods: {
    redirectToDashboard () {
      if (!this.$router || !this.$route || this.$route.name !== 'home') {
        return
      }

      this.$router.replace({
        name: 'dashboard',
        query: this.$route.query || {}
      }).catch(function () {})
    }
  }
}
